/* src/app/FW/controls/multicombobox/multicombobox.component.scss */
:host ::ng-deep .ng-value-container {
  min-height: 2px;
}
:host ::ng-deep .ng-select .ng-select-container {
  min-height: 2px;
}
:host ::ng-deep .ng-select.ng-select-single .ng-select-container {
  height: 2px;
}
:host ::ng-deep .ng-select.ng-select-multiple .ng-select-container .ng-value-container {
  padding-top: 0px;
  padding-left: 7px;
}
.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup,
.ng-dropdown-panel .ng-dropdown-panel-items .ng-option {
  white-space: normal !important;
  word-wrap: break-word !important;
}
button.btntest.btn.btn-sm.btn-secondary.ng-star-inserted {
  color: #000;
}
/*# sourceMappingURL=multicombobox.component.css.map */
